import { Injectable } from '@angular/core';

@Injectable()
export class GtmService {
  constructor() {}

  /**
   * Initialization GOOGLE TAG MANAGER
   */
  public activeGTagManager(): void {
    /* eslint-disable */
    const script = document.createElement('script');
    const startScriptComment = document.createComment('Google Tag Manager');
    const endScriptComment = document.createComment('End Google Tag Manager');

    script.type = 'text/javascript';
    script.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-5VQGBXG');
    `;
    document.head.appendChild(startScriptComment);
    document.head.appendChild(script);
    document.head.appendChild(endScriptComment);

    const noScript = document.createElement('noscript');
    const startNoScriptComment = document.createComment('Google Tag Manager (noscript)');
    const endNoScriptComment = document.createComment('End Google Tag Manager (noscript)');
    noScript.innerHTML = `\<\iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5VQGBXG" height="0" width="0" style="display: none; visibility: hidden" ></iframe >`;
    document.body.appendChild(startNoScriptComment);
    document.body.appendChild(noScript);
    document.body.appendChild(endNoScriptComment);
    /* eslint-enable */
  }
}
